export default function Footer() {
  return (
    <footer id="footer" className="bg-foreground-900 text-background-50/70 pt-14 md:pt-20 pb-8 px-4 md:px-6">
      <div className="max-w-[1400px] mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12 mb-12">
          <div>
            <h3 className="text-xl font-heading text-background-50 mb-4">羞羞漫画</h3>
            <p className="text-sm text-background-50/50 leading-relaxed">
              海量韩漫、日漫、国漫免费在线阅读平台，支持下拉式阅读与实时追更。每日更新热门推荐，为漫画爱好者提供纯净的免费阅读体验。
            </p>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-50 mb-4">快速导航</h3>
            <ul className="space-y-2.5">
              {[
                { label: '排行榜', href: '#ranking' },
                { label: '平台特色', href: '#features' },
                { label: '精彩视频', href: '#media' },
                { label: '焦点专题', href: '#carousel' },
                { label: '常见问题', href: '#faq' },
              ].map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    onClick={(e) => {
                      e.preventDefault();
                      document.querySelector(link.href)?.scrollIntoView({ behavior: 'smooth' });
                    }}
                    className="text-sm text-background-50/50 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-50 mb-4">漫画分类</h3>
            <ul className="space-y-2.5">
              <li><span className="text-sm text-background-50/50 whitespace-nowrap">韩漫大全</span></li>
              <li><span className="text-sm text-background-50/50 whitespace-nowrap">日漫精选</span></li>
              <li><span className="text-sm text-background-50/50 whitespace-nowrap">国漫专区</span></li>
              <li><span className="text-sm text-background-50/50 whitespace-nowrap">恋爱言情</span></li>
              <li><span className="text-sm text-background-50/50 whitespace-nowrap">玄幻修仙</span></li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-50 mb-4">合作伙伴</h3>
            <p className="text-sm text-background-50/40 leading-relaxed">
              更多合作伙伴即将揭晓，敬请期待。
            </p>
          </div>
        </div>

        <div className="border-t border-background-50/10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-50/40">
            &copy; 2026 羞羞漫画. 海量韩漫日漫国漫免费在线阅读平台.
          </p>
          <div className="flex items-center gap-4">
            <a href="#hero" onClick={(e) => { e.preventDefault(); document.querySelector('#hero')?.scrollIntoView({ behavior: 'smooth' }); }} className="text-xs text-background-50/40 hover:text-background-50/70 transition-colors cursor-pointer whitespace-nowrap">回到顶部</a>
          </div>
        </div>
      </div>
    </footer>
  );
}